import { Loader2 } from "lucide-react";
import type React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";

interface BlockUserConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  dialogTitle: string;
  dialogDescription: string;
  cancelText: string;
  confirmText: string;
  isLoading: boolean;
  onConfirm: () => Promise<void> | void;
  variant?: "destructive" | "secondary";
}

export const BlockUserConfirmDialog: React.FC<BlockUserConfirmDialogProps> = ({
  isOpen,
  onClose,
  dialogTitle,
  dialogDescription,
  cancelText,
  confirmText,
  isLoading,
  onConfirm,
  variant = "destructive",
}) => {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        hideCloseButton
        className="w-full max-w-md rounded-lg p-6"
        data-user-popup-block-dialog="true"
      >
        <DialogTitle className="text-lg font-semibold">
          {dialogTitle}
        </DialogTitle>
        <DialogDescription className="mt-2 text-sm text-gray-500">
          {dialogDescription}
        </DialogDescription>

        <div className="mt-4 flex justify-end space-x-2">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelText}
          </Button>

          <Button
            type="button"
            variant={variant}
            onClick={() => void onConfirm()}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 className="size-4 animate-spin" />
                {confirmText}
              </>
            ) : (
              confirmText
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
